import PasswordModal from './PasswordModal'
Vue.component('PasswordModal', PasswordModal)

import SuccessModal from './SuccessModal'
Vue.component('SuccessModal', SuccessModal)



// WEBPACK FOOTER //
// ./src/js/components/Modals/index.js